const Jump = () => import('@/views/jump/Index.vue')

export default [
  { path: '/jump', name:'Jump', component: Jump },
]
